export default __webpack_public_path__ + "static/media/member1.403915d1.png";